import { atom } from 'jotai'
import { atomWithStorage } from 'jotai/utils'

export const userIDAtom = atom('')
export const firstNameAtom = atom('')
export const lastNameAtom = atom('')
export const emailAtom = atom('')
export const authenticatedAtom = atom(false)
